// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ourAchievements_body__Hw3fe {
  margin: 170px 0;
}

.ourAchievements_wrapper__QFlCm {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ourAchievements_left__FLhhz {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  color: #111827;
  grid-gap: 6px;
  font-family: Inter;
}
.ourAchievements_left__FLhhz h3 {
  font-weight: 700;
  font-size: 48px;
  line-height: 60px;
  letter-spacing: -1px;
}
.ourAchievements_left__FLhhz p {
  font-size: 18px;
  line-height: 28px;
}

.ourAchievements_content__IqDHG {
  display: grid;
  grid-template-columns: repeat(2, 280px);
  grid-template-rows: repeat(1, 1fr);
  grid-gap: 30px;
}
.ourAchievements_content__IqDHG .ourAchievements_item__1c-0f {
  color: #111827;
  font-family: Inter;
}
.ourAchievements_content__IqDHG .ourAchievements_item__1c-0f h4 {
  font-size: 36px;
  letter-spacing: -1px;
  font-weight: 700;
}
.ourAchievements_content__IqDHG .ourAchievements_item__1c-0f span {
  font-weight: 400;
  font-size: 16px;
}

@media (max-width: 1170px) {
  .ourAchievements_left__FLhhz h3 {
    font-size: 44px;
    line-height: 56px;
  }
  .ourAchievements_content__IqDHG {
    grid-gap: 0;
  }
}
@media (max-width: 1024px) {
  .ourAchievements_wrapper__QFlCm {
    grid-gap: 10px;
  }
  .ourAchievements_left__FLhhz h3 {
    font-size: 38px;
    line-height: 46px;
  }
  .ourAchievements_left__FLhhz p {
    font-size: 17px;
  }
  .ourAchievements_content__IqDHG {
    grid-gap: 0;
  }
}
@media (max-width: 930px) {
  .ourAchievements_body__Hw3fe {
    margin: 100px 0;
  }
  .ourAchievements_wrapper__QFlCm {
    flex-direction: column;
    align-items: flex-start;
  }
  .ourAchievements_left__FLhhz {
    width: 100%;
  }
  .ourAchievements_content__IqDHG {
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(1, 1fr);
  }
}
@media (max-width: 768px) {
  .ourAchievements_body__Hw3fe {
    margin: 75px 0;
  }
  .ourAchievements_item__1c-0f h4 {
    font-size: 32px !important;
  }
}
@media (max-width: 430px) {
  .ourAchievements_body__Hw3fe {
    margin: 80px 0;
  }
  .ourAchievements_left__FLhhz h3 {
    font-size: 36px;
    line-height: 46px;
  }
  .ourAchievements_left__FLhhz p {
    font-size: 16px;
  }
  .ourAchievements_wrapper__QFlCm {
    flex-direction: column;
  }
  .ourAchievements_content__IqDHG {
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(auto, 1fr);
    grid-gap: 20px;
    justify-content: center;
  }
  .ourAchievements_content__IqDHG .ourAchievements_item__1c-0f h4 {
    font-size: 28px;
  }
  .ourAchievements_content__IqDHG .ourAchievements_item__1c-0f span {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ourAchievements/ourAchievements.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AACJ;AAEE;EACE,eAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,uCAAA;EACA,kCAAA;EACA,cAAA;AADF;AAGE;EACE,cAAA;EACA,kBAAA;AADJ;AAGI;EACE,eAAA;EACA,oBAAA;EACA,gBAAA;AADN;AAII;EACE,gBAAA;EACA,eAAA;AAFN;;AAOA;EAEI;IACE,eAAA;IACA,iBAAA;EALJ;EAQA;IACE,WAAA;EANF;AACF;AAUA;EACE;IACE,cAAA;EARF;EAWE;IACE,eAAA;IACA,iBAAA;EATJ;EAWE;IACE,eAAA;EATJ;EAYA;IACE,WAAA;EAVF;AACF;AAaA;EACE;IACE,eAAA;EAXF;EAaA;IACE,sBAAA;IACA,uBAAA;EAXF;EAaA;IACE,WAAA;EAXF;EAaA;IACE,WAAA;IACA,qCAAA;IACA,kCAAA;EAXF;AACF;AAeA;EACE;IACE,cAAA;EAbF;EAgBE;IACE,0BAAA;EAdJ;AACF;AAkBA;EACE;IACE,cAAA;EAhBF;EAoBE;IACE,eAAA;IACA,iBAAA;EAlBJ;EAoBE;IACE,eAAA;EAlBJ;EAsBA;IACE,sBAAA;EApBF;EAuBA;IACE,WAAA;IACA,qCAAA;IACA,qCAAA;IACA,cAAA;IACA,uBAAA;EArBF;EAwBI;IACE,eAAA;EAtBN;EAyBI;IACE,eAAA;EAvBN;AACF","sourcesContent":[".body {\r\n  margin: 170px 0;\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.left {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  flex-direction: column;\r\n  color: #111827;\r\n  grid-gap: 6px;\r\n  font-family: Inter;\r\n\r\n  h3 {\r\n    font-weight: 700;\r\n    font-size: 48px;\r\n    line-height: 60px;\r\n    letter-spacing: -1px;\r\n  }\r\n\r\n  p {\r\n    font-size: 18px;\r\n    line-height: 28px;\r\n  }\r\n}\r\n\r\n.content {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 280px);\r\n  grid-template-rows: repeat(1, 1fr);\r\n  grid-gap: 30px;\r\n\r\n  .item {\r\n    color: #111827;\r\n    font-family: Inter;\r\n\r\n    h4 {\r\n      font-size: 36px;\r\n      letter-spacing: -1px;\r\n      font-weight: 700;\r\n    }\r\n\r\n    span {\r\n      font-weight: 400;\r\n      font-size: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 1170px) {\r\n  .left {\r\n    h3 {\r\n      font-size: 44px;\r\n      line-height: 56px;\r\n    }\r\n  }\r\n  .content {\r\n    grid-gap: 0;\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .wrapper {\r\n    grid-gap: 10px;\r\n  }\r\n  .left {\r\n    h3 {\r\n      font-size: 38px;\r\n      line-height: 46px;\r\n    }\r\n    p {\r\n      font-size: 17px;\r\n    }\r\n  }\r\n  .content {\r\n    grid-gap: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 930px) {\r\n  .body {\r\n    margin: 100px 0;\r\n  }\r\n  .wrapper {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  .left {\r\n    width: 100%;\r\n  }\r\n  .content {\r\n    width: 100%;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-template-rows: repeat(1, 1fr);\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .body {\r\n    margin: 75px 0;\r\n  }\r\n  .item {\r\n    h4 {\r\n      font-size: 32px !important;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 430px) {\r\n  .body {\r\n    margin: 80px 0;\r\n  }\r\n\r\n  .left {\r\n    h3 {\r\n      font-size: 36px;\r\n      line-height: 46px;\r\n    }\r\n    p { \r\n      font-size: 16px;\r\n    }\r\n  }\r\n\r\n  .wrapper {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .content {\r\n    width: 100%;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    grid-template-rows: repeat(auto, 1fr);\r\n    grid-gap: 20px;\r\n    justify-content: center;\r\n    .item {\r\n\r\n      h4 {\r\n        font-size: 28px;\r\n      }\r\n\r\n      span {\r\n        font-size: 14px;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `ourAchievements_body__Hw3fe`,
	"wrapper": `ourAchievements_wrapper__QFlCm`,
	"left": `ourAchievements_left__FLhhz`,
	"content": `ourAchievements_content__IqDHG`,
	"item": `ourAchievements_item__1c-0f`
};
export default ___CSS_LOADER_EXPORT___;
